import {css} from '@sail/ui';

// From Sail Next <Link> styles
export const secondaryLinkStyles = (selector: string) =>
  css.global({
    [`:where(${selector}) a`]: {
      textColor: 'action.secondary',
      textDecoration: 'underline',
      textUnderlineOffset: '2px',
      textDecorationThickness: '0.07em',
    },
    [`:where(${selector}) a:hover`]: {
      textColor: 'action.secondary.hovered',
    },
  });
